<div class="page-title">
  <div class="page-title__title-left">
    <span>Step {{ totalSteps }}/{{ totalSteps }}</span>
    <h1>{{ paymentStepName }}</h1>
  </div>
  <div class="page-title__next-btn">
    <button class="btn btn--secondary mr-0" (click)="onBack()">
      <svg class="ml-0" width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.33334 1.33331L1 4.56249L4.33334 7.79167" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M1 4.56247L6.33335 4.56247C10.0154 4.56247 13 7.45387 13 11.0208V11.6667"
          stroke="white"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      Back
    </button>
  </div>
</div>

<app-collect-payment [salesOrderId]="salesOrderId" [flowType]="flowType" [applicableFor]="applicableFor" [appointmentRequest]="appointmentRequest"></app-collect-payment>
